import { render, staticRenderFns } from "./ShowAnswers.vue?vue&type=template&id=971fd02c&scoped=true"
import script from "./ShowAnswers.vue?vue&type=script&lang=js"
export * from "./ShowAnswers.vue?vue&type=script&lang=js"
import style0 from "./ShowAnswers.vue?vue&type=style&index=0&id=971fd02c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971fd02c",
  null
  
)

export default component.exports